<template>
  <KTLoader v-if="loaderEnabled" :logo="loaderLogo"></KTLoader>

  <!-- begin:: Body -->
  <div class="page d-flex flex-row flex-column-fluid">
    <div id="kt_wrapper" class="wrapper d-flex flex-column flex-row-fluid">
      <KTHeaderSimple></KTHeaderSimple>

      <!-- begin:: Content -->
      <div
        id="kt_content"
        class="d-flex flex-column-fluid align-items-start"
        :class="{
          'container-fluid': contentWidthFluid,
          container: !contentWidthFluid,
        }"
      >
        <!-- begin:: Content Body -->
        <div class="content flex-row-fluid">
          <router-view />
        </div>
        <!-- end:: Content Body -->
      </div>
      <!-- end:: Content -->
    </div>
  </div>
  <!-- end:: Body -->
  <KTScrollTop></KTScrollTop>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import KTHeaderSimple from "@/layout/header/HeaderSimple.vue";
import HtmlClass from "@/core/services/LayoutService";
import KTScrollTop from "@/layout/extras/ScrollTop.vue";
import KTLoader from "@/components/Loader.vue";
import { Actions } from "@/store/enums/StoreEnums";
import {
  loaderEnabled,
  contentWidthFluid,
  loaderLogo,
} from "@/core/helpers/config";

export default defineComponent({
  name: "LayoutNoFooter",
  components: {
    KTHeaderSimple,
    KTScrollTop,
    KTLoader,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

    HtmlClass.init();

    const pageTitle = computed(() => {
      return store.getters.pageTitle;
    });

    onMounted(() => {
      if (!store.getters.isUserAuthenticated) {
        router.push({ name: "sign-in" });
      }
      setTimeout(() => {
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      }, 500);
    });

    return {
      loaderEnabled,
      contentWidthFluid,
      loaderLogo,
      pageTitle,
    };
  },
});
</script>
